import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiStar, FiPhone, FiCheckCircle } = FiIcons;

function Hero() {
  const reduceMotion = useReducedMotion();

  return (
    <section className="hero" id="top">
      {/* Replace this placeholder with a real Windy City Painters project photo before launch. */}
      <motion.div
        className="hero-image"
        initial={reduceMotion ? false : { scale: 1 }}
        animate={reduceMotion ? {} : { scale: 1.08 }}
        transition={{ duration: 18, ease: 'linear', repeat: Infinity, repeatType: 'reverse' }}
      />
      <div className="hero-overlay" />

      <div className="container hero-content">
        <motion.span
          className="eyebrow"
          initial={reduceMotion ? false : { opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          Austin's trusted painting team since 2008
        </motion.span>

        <motion.h1
          initial={reduceMotion ? false : { opacity: 0, y: 34 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.12, duration: 0.8 }}
        >
          Austin Painting,<br />
          <em>Done Right</em> the First Time.
        </motion.h1>

        <motion.p
          className="hero-copy"
          initial={reduceMotion ? false : { opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.24, duration: 0.8 }}
        >
          20+ years of interior, exterior, commercial, and specialty painting —
          delivered on time, on budget, with zero surprises.
        </motion.p>

        <motion.div
          className="hero-actions"
          initial={reduceMotion ? false : { opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.36, duration: 0.8 }}
        >
          <a className="button glow" href="#contact">Get My Free Estimate</a>
          <a className="button button-outline" href="#gallery">See Our Work</a>
        </motion.div>

        <motion.div
          className="trust-row"
          initial={reduceMotion ? false : { opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.55, duration: 0.8 }}
        >
          <span><SafeIcon icon={FiStar} /> Loved by Austin homeowners</span>
          <span><SafeIcon icon={FiPhone} /> 512-679-2228</span>
          <span><SafeIcon icon={FiCheckCircle} /> NAPCO-Certified</span>
        </motion.div>
      </div>
    </section>
  );
}

export default Hero;